module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11ztLij/tc-custom/9780292786165.jpg?1728725961669",
      "alt": "This image is the cover for the book Confederate Cavalry West of the River"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Confederate Cavalry West of the River\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v(" Another Confederate cavalry raid impends. You hear the snort of an impatient horse, the leathery squeaking of saddles, the low-voiced commands of officers, the muffled cluck of guns cocked in preparation—then the sudden rush of motion, the din of another attack. ")]), _c('p', [_vm._v(" This classic story seeks to illuminate a little-known theater of the Civil War—the cavalry battles of the Trans-Mississippi West, a region that included Missouri, Arkansas, Texas, the Indian Territory, and part of Louisiana. Stephen B. Oates traces the successes and defeats of the cavalry; its brief reinvigoration under John S. \"Rip\" Ford, who fought and won the last battle of the war at Palmetto Ranch; and finally, the disintegration of this once-proud fighting force. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephen B. Oates\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    University of Texas Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0